/* eslint-disable */
import { RefObject } from 'react';
import { HierarchyItem, LevelDataMap } from './types';

const updateLevelDataMaps = (
	levelDataMaps,
	dataArray,
	selections,
	parentItem?
) => {
	dataArray.forEach((item) => {
		item.subHierarchy = item.subHierarchy || [];
		item.parentNestedId = parentItem?.nestedId;
		if (!levelDataMaps[item.level]) {
			levelDataMaps[item.level] = new Map();
		}
		levelDataMaps[item.level].set(item.nestedId, item);

		updateLevelDataMaps(levelDataMaps, item.subHierarchy, selections, item);
	});
};

export const getLevelDataMaps = (dataArray, selectionArray) => {
	if (!dataArray || dataArray.length < 1) {
		return null;
	}

	const selections = selectionArray || [];

	const levelDataMaps = [];

	updateLevelDataMaps(levelDataMaps, dataArray, selections);

	return levelDataMaps;
};

export const NO_OP = () => {};

function hasKey<T>(key: PropertyKey, obj: T): key is keyof T {
	return !!obj[key];
}

// Return true/false if a HierarchyItem is in an Array of LevelDataMaps
// or in a React ref of an Array of LevelDataMaps
export const hasItem = (
	levelMap: RefObject<LevelDataMap[]> | LevelDataMap[],
	item: HierarchyItem
) => {
	const mapArray = hasKey('current', levelMap) ? levelMap['current'] : levelMap;
	return mapArray[item.level]?.has(item.nestedId) ?? false;
};

export const getParentItem = (mapArray: LevelDataMap[], item: HierarchyItem) =>
	item.parentNestedId && mapArray[item.level - 1]?.get(item.parentNestedId);

// Return true/false if any HierarchyItem's ancestors are in an Array of LevelDataMaps
// Requires an Array of all of the level data
export const hasAncestor = (
	levelMap: RefObject<LevelDataMap[]> | LevelDataMap[],
	item: HierarchyItem,
	allLevelDataMap: LevelDataMap[]
) => {
	const mapArray = hasKey('current', levelMap) ? levelMap['current'] : levelMap;
	const parentItem = getParentItem(allLevelDataMap, item);
	if (!parentItem) return false;
	return (
		hasItem(mapArray, parentItem) ||
		hasAncestor(levelMap, parentItem, allLevelDataMap)
	);
};
